import ReserveTokenArtifact from "./abi/ReserveToken.json";
import { formatUnits } from "ethers/lib/utils";
import { ethers } from "ethers";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import {PROJECT_STATUSES} from "./constants/constants";
dayjs.extend(relativeTime);



// Constant to pull zeros from for multipliers
let zeros = "0";
while (zeros.length < 256) { zeros += zeros; }

export const getERC20 = async (erc20Address, signer) => {
    let erc20AddressError,
        erc20Contract,
        erc20name,
        erc20symbol,
        erc20balance,
        erc20decimals,
        erc20totalSupply;

    if (ethers.utils.isAddress(erc20Address)) {
        erc20AddressError = null;
        erc20Contract = new ethers.Contract(erc20Address, ReserveTokenArtifact.abi);
        erc20Contract = erc20Contract.connect(signer);
        try {
            erc20name = await erc20Contract.name();
            erc20symbol = await erc20Contract.symbol();
            erc20balance = await erc20Contract.balanceOf(signer._address);
            erc20decimals = await erc20Contract.decimals();
            erc20totalSupply = await erc20Contract.totalSupply();
            return {
                erc20Contract,
                erc20name,
                erc20symbol,
                erc20balance,
                erc20decimals,
                erc20AddressError,
                erc20totalSupply,
            };
        } catch (error) {
            erc20AddressError = "not a valid ERC20 token address";
        }
    } else {
        erc20AddressError = "not a valid address";
    }
};

export const formatNumberComma = (numberToFormat) =>
    numberToFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const getAfterTimestampDate = (stateConfig, format = "DD-MM-YYYY") => {
    
    if(stateConfig.timestamp)
        return getUnixTimeStamp(stateConfig.timestamp, format);

    return dayjs.unix(parseInt(stateConfig.constants[0])).format(format)
};

export const getUnixTimeStamp = (time, format = "DD-MM-YYYY") =>
    dayjs.unix(time).format(format)

export const getAfterTimeStampStrapi = (time, format = "DD-MM-YYYY") => dayjs(time).format(format);

export const getRelativeTime = (stateConfig) => {
    return dayjs().to(dayjs(stateConfig.constants[0] * 1000), true);
};

export function addEllipses(address) {
    return address.substring(0, 4) + "...." + address.substring(address.length - 5)
}

export function formatNumber(number, decimal) {
    return formateToPrecision(Number((+formatUnits(number, decimal))))
}

export function getTokenPrice(projectMeta) {
    return formateToPrecision(formatNumber(projectMeta.calculatePriceStateConfig.constants[0], projectMeta.reserve.decimals));
}

export function getWalletCap(projectMeta) {
    return formateToPrecision(Number((+formatUnits(projectMeta.calculatePriceStateConfig.constants[1]))));
}

export function tierReport(report) {
    const parsedReport = [];
    const arrStatus = [0, 1, 2, 3, 4]
        .map((i) =>
            BigInt(report)
                .toString(16)
                .padStart(64, "0")
                .slice(i * 8, i * 8 + 8)
        )
        .reverse();

    for (const i in arrStatus) {
        parsedReport.push(parseInt("0x" + arrStatus[i]));
    }

    return parsedReport;
}

// to split a timestamp into the separate components
export function splitTime(timestamp) {
    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;
    const msPerWeek = msPerDay * 7;
    const msPerMonth = msPerDay * 30;
    const msPerYear = msPerDay * 365;

    let weeks = Math.floor(timestamp / msPerWeek);
    let lessWeeks = timestamp % msPerWeek;
    let days = Math.floor(lessWeeks / msPerDay);
    let lessDays = lessWeeks % msPerDay;
    let hours = Math.floor(lessDays / msPerHour);
    let lessHours = lessDays % msPerHour;
    let minutes = Math.floor(lessHours / msPerMinute);
    let lessMinutes = lessHours % msPerMinute;
    let seconds = Math.floor(lessMinutes / 1000);

    return [weeks, days, hours, minutes, seconds];
}

export function timeString(timestamp, options) {
    const timeArray = splitTime(Math.abs(timestamp));
    const weeks = timeArray[0] ? timeArray[0] + "w " : "";
    const days = timeArray[1] ? timeArray[1] + "d " : "";
    const hours = timeArray[2] ? timeArray[2] + "h " : "";
    const minutes = timeArray[3] ? timeArray[3] + "m " : "";
    const seconds = timeArray[4] ? timeArray[4] + "s" : "";

    const strings = new Map([
        ["wdhms", weeks + days + hours + minutes + seconds],
        ["wdhm", weeks + days + hours + minutes],
        ["wdh", weeks + days + hours],
        ["wd", weeks + days],
        ["w", weeks],
    ]);

    return strings.get(options) || weeks + days + hours + minutes + seconds;
}


export const getAfterTimestampDateFormat = (stateConfig) => {
    return new Date(parseInt(stateConfig.constants[0]) * 1000);

};

// update the time elapse/remaining
export const getTime = (sale) => {
    const now = Math.floor(Date.now() / 1000);
    const end = getAfterTimestampDateFormat(sale.canEndStateConfig).getTime() / 1000;
    const start = getAfterTimestampDateFormat(sale.canEndStateConfig).getTime() / 1000;
    const timeRemaining = end - now > 0 ? timeString((end - now) * 1000) : "Raise Ended";
    const timeElapsed = timeString((now - start) * 1000);
    return {
        timeRemaining,
        timeElapsed
    }
};

export const serialize = (object) => {
    let str = '?' + Object.keys(object).reduce(function (a, k) {
        a.push(k + '=' + encodeURIComponent(object[k]));
        return a;
    }, []).join('&');
    return str;
}

export const IMAGE_STRING_REGEX = /\!\[.*\]\(.*\)/g

export const prependUrlToImages = (mdFileOutput, baseUrl) => {
    let source = mdFileOutput
    const projectImagesUrls = [...new Set(mdFileOutput.match(IMAGE_STRING_REGEX))]
    projectImagesUrls.forEach((url) => {
        let extractImageUrl = url.substring(url.indexOf("/uploads"), url.length - 1)
        let modifiedImageUrl = baseUrl + extractImageUrl
        source = source.replaceAll(extractImageUrl, modifiedImageUrl)
    })
    return source
}

export const formateToPrecision = (value) => {
    if(!value) return value;
    let splitNumbers = `${value}`.split('.');

    if(splitNumbers.length == 1)
        return value;
    else if(splitNumbers.length == 2){
        return Number(value).toPrecision(splitNumbers[0].length + 3)/1;
    }else
        return 'invalid value';
}

export const validateField = (field, message, validateRule) => {

    if (!field?.trim())
        return `${message} is required`;
    if (validateRule)
        if (validateRule(field))
            return `${message} should be valid`;
    return '';
}

export const formatScientificNumber = (num) => {
    let sign = "";
    (num += "").charAt(0) == "-" && (num = num.substring(1), sign = "-");
    let arr = num.split(/[e]/ig);
    if (arr.length < 2) return sign + num;
    let dot = (.1).toLocaleString().substr(1, 1), n = arr[0], exp = +arr[1],
        w = (n = n.replace(/^0+/, '')).replace(dot, ''),
      pos = n.split(dot)[1] ? n.indexOf(dot) + exp : w.length + exp,
      L   = pos - w.length, s = "" + BigInt(w);
      w   = exp >= 0 ? (L >= 0 ? s + "0".repeat(L) : r()) : (pos <= 0 ? "0" + dot + "0".repeat(Math.abs(pos)) + s : r());
    L= w.split(dot); if (L[0]==0 && L[1]==0 || (+w==0 && +s==0) ) w = 0; //** added 9/10/2021
    return sign + w;
    function r() {return w.replace(new RegExp(`^(.{${pos}})(.)`), `$1${dot}$2`)}
  }

export const getProjectStatus = (projectStartTime, projectEndTime) => {
    let currentTimestamp = Date.parse(new Date())
    let projectStartTimestamp = Date.parse(projectStartTime)
    let projectEndTimestamp = Date.parse(projectEndTime)
    return currentTimestamp < projectStartTimestamp
        ? PROJECT_STATUSES.UPCOMING
        : currentTimestamp > projectStartTimestamp &&
        currentTimestamp < projectEndTimestamp
        ? PROJECT_STATUSES.LIVE
        : PROJECT_STATUSES.COMPLETED
}